import React from 'react'
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const TopPage = () => {
    return (
        <div className="App">
        <header className="App-header">
          <p>Neveless Fab</p>
          <div>We're making it slowly.</div>
          <Button color="inherit" component={Link} to="/info">Enter</Button>
        </header>
      </div>
    );
}

export default TopPage